import { useTranslation } from "react-i18next"
import useDomainName from "./useDomainName"

export const useAppLanguage = () => {
  const { i18n } = useTranslation()
  const { langSlug } = useDomainName()

  return i18n?.language ?? langSlug ?? "en"
}
